
















import { Component, Vue, Watch } from 'vue-property-decorator';
import { sessionModule } from '@/trials/store/modules/session';
import { SysConst as SC } from '@/trials/plugins/const';

import NotificationDialogData from '@/trials/domain/objects/notificationDialogData';

@Component
export default class NotificationDialog extends Vue {
    /*----------------------------------*
     * 変数
     *-----------------------------------*/
    private width: number = SC.Dialog.WIDTH;

    /*----------------------------------*
     * props
     *-----------------------------------*/
    private isShow: boolean = false;

    /*----------------------------------*
     * ライフサイクルフック
     *-----------------------------------*/

    /*----------------------------------*
     * Computed
     *-----------------------------------*/
    public get dialogData(): NotificationDialogData | null {
        return sessionModule.getNotificationDialogData;
    }

    public get messageKey(): string {
        return this.dialogData !== null ? this.dialogData.messageKey : '';
    }

    /*----------------------------------*
     * Watch
     *-----------------------------------*/
    @Watch('dialogData')
    changeDialogData(val: NotificationDialogData | null, oldVal: NotificationDialogData | null) {
        if (val != null && oldVal == null) {
            this.isShow = true;
        } else {
            this.isShow = false;
        }
    }

    /*----------------------------------*
     * Methods
     *-----------------------------------*/
    private closeDialog(): void {
        sessionModule.closeNotificationDialog();
    }
}
